// src/components/common/StatCard.jsx
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { BG_ELEVATED, BORDER_SECTION, TEXT_SECONDARY } from '../../utils/colors';

const StatCard = ({ label, children }) => (
  <Box sx={{
    flex: 1,
    bgcolor: BG_ELEVATED,
    border: `1px solid ${BORDER_SECTION}`,
    borderRadius: 1.5,
    p: 1.5,
    minWidth: 0,
    minHeight: 88,
  }}>
    <Box sx={{
      color: TEXT_SECONDARY,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      fontSize: '0.65rem',
      display: 'flex',
      alignItems: 'center',
      mb: 0.75,
      lineHeight: 1.5,
    }}>
      {label}
    </Box>
    {children}
  </Box>
);

StatCard.propTypes = {
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default StatCard;
